import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { studyEDCLupReportingServices } from "../../../../APIServices/studyEDCLupReportingServices";

const UpdateLUPReport = ({ Show, Hide, Title, reportData, setReportData, setReportId, getLupReportMetadatasData }) => {
  let { studyId } = useParams();
  const [reportName, setReportName] = useState("");
  const [reportNumber, setReportNumber] = useState("");
  const [reportType, setReportType] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [category, setCategory] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getLupReportCategorysData = async (e) => {
    let data = await studyEDCLupReportingServices.getLupReportCategorysData(
      "active", 
      studyId,
    );
    setCategory(data?.data || []);
  };
  
  const updateLupReportMetadatas = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Report!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {}
        userData.id = reportData?._id
        userData.reportId = reportData?.reportId
        userData.reportName = reportName
        userData.reportNumber = reportNumber
        userData.reportType = reportType
        userData.reportDescription = reportDescription
        userData.studyId = studyId
        let data = await studyEDCLupReportingServices.updateLupReportMetadatas(userData);
        if (data?.statusCode === 200) {
          getLupReportMetadatasData();
          setReportData("")
          setReportId("")
          Hide()
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setReportName(reportData?.reportName);
    setReportNumber(reportData?.reportNumber);
    setReportType(reportData?.reportType);
    setReportDescription(reportData?.reportDescription);
    getLupReportCategorysData()
  }, [reportData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Report Number{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              className="fontSize12"
              placeholder="Enter Report Number"
              onChange={(e) => setReportNumber(e.target.value)}
              value={reportNumber}
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Report Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              className="fontSize12"
              placeholder="Enter Report Name"
              onChange={(e) => setReportName(e.target.value)}
              value={reportName}
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Report Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
            >
              <option value="">Select Report Type</option>
              {category?.length > 0 &&
                category?.map((item, key) => (
                  <option value={item.categoryId} key={key}>
                    {item.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Report Description{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              className="fontSize12"
              placeholder="Enter Report Description"
              onChange={(e) => setReportDescription(e.target.value)}
              value={reportDescription}
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={updateLupReportMetadatas}
            disabled={!reportName || buttonLoader}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Report"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateLUPReport;
